import type { FC } from "react";

import { PENCIL_EDIT_ICON_PATHS } from "mds/utils/icon-paths";
import { type IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PencilEditIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {PENCIL_EDIT_ICON_PATHS.map((d, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <path d={d} fill="currentColor" key={i} />
    ))}
  </svg>
);
